import React from 'react';
import { axiosApi } from '../../assets/axiosAPI';
import { Redirect } from 'react-router-dom';
import { API_PATH } from '../../assets/const';
import { killSessionLoginInfo } from '../../assets/common';

export default class Logout extends React.Component{
    constructor(props){
        super(props);
    }
    componentDidMount(){
        killSessionLoginInfo();
    }

    render(){
        if(this.props.pathName === "Logout"){
            return(
                <Redirect to={'/Login'} />
            )
        }else{
            return(
                <Redirect to={'/AdminLogin'} />
            )
        }
    }

}